class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Mega menu sub-item popovers (header-mega-menu.liquid), opened by the caret next to a heading
    this.popups = this.querySelectorAll('.mega-menu__popup[popover]');
    if (!this.popups.length || !HTMLElement.prototype.hasOwnProperty('popover')) return;

    this.popups.forEach((popup) => {
      popup.addEventListener('beforetoggle', (event) => this.onPopupToggle(popup, event.newState === 'open'));
    });

    // The popovers are fixed-position, so close them rather than let them drift when anything scrolls
    const closePopups = this.closePopups.bind(this);
    this.content.addEventListener('scroll', closePopups, { passive: true });
    window.addEventListener('scroll', closePopups, { passive: true });
    window.addEventListener('resize', closePopups);
  }

  onPopupToggle(popup, isOpening) {
    const anchor = popup.previousElementSibling;
    anchor.querySelector('.mega-menu__group-toggle').setAttribute('aria-expanded', isOpening);
    if (!isOpening) return;

    const gutter = 16;
    const rect = anchor.getBoundingClientRect();
    popup.style.top = `${rect.bottom + 6}px`;
    popup.style.left = `${rect.left}px`;
    popup.style.maxHeight = `${window.innerHeight - rect.bottom - 6 - gutter}px`;

    // Once rendered, keep it inside the viewport's right edge
    requestAnimationFrame(() => {
      const overflow = popup.getBoundingClientRect().right - (window.innerWidth - gutter);
      if (overflow > 0) popup.style.left = `${Math.max(gutter, rect.left - overflow)}px`;
    });
  }

  closePopups() {
    this.popups.forEach((popup) => {
      if (popup.matches(':popover-open')) popup.hidePopover();
    });
  }

  onToggle() {
    if (!this.mainDetailsToggle.open && this.popups.length && HTMLElement.prototype.hasOwnProperty('popover')) {
      this.closePopups();
    }

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
